import React, { useState, useEffect, useMemo } from "react";
import jwt_decode from "jwt-decode";
import { Buffer } from "buffer";
import packageJson from "../../../../package.json";
import {
  CheckIsLais,
  CheckSurvey,
  GET_ACTIVE_ACAD,
} from "./APIs";
import { CardLais, CardSessionTimeout, CardUnregis } from "./CardInfo";
import LoadingBtn from "../../Page/Widgets/LoadingBtn";
import { AlertNotif } from "../../Library/AlertNotif";
import {
  RouteLecturer,
  RouteStudent,
  RouteStudentNewComming,
} from "../../Routes";
import { Error404 } from "../../Library/LoaderPage";
import { openModal, PopUpMessage } from "../../Library/ModalPopUp";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function PageContent({ is_student = false, std_data = [], menu }) {
  var currDatetime = new Date();
  currDatetime = currDatetime.getTime();
  const [acad, setAcad] = useState({ loading: false, message: "", data: [] });

  const str_key_name = "active_acad";
  const ReloadActiveCalendar = async () => {
    setAcad({ loading: true, data: [], message: "" });
    const results = await GET_ACTIVE_ACAD();
    if (results.data && Object.values(results.data).length > 0) {
      const data = results.data.filter((item) => item.atp_id_term !== 116);
      localStorage.setItem(str_key_name, JSON.stringify(data));
      setAcad({ loading: false, message: "", data: data });
    } else {
      localStorage.setItem(str_key_name, "");
      setAcad(results);
    }
  }

  useEffect(() => {
    const loadData = async () => {
      const storedData = localStorage.getItem(str_key_name);
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          setAcad({ loading: false, message: "", data: data });
        } catch (error) {
          console.error("Error parsing stored data:", error);
          await ReloadActiveCalendar();
        }
      } else {
        await ReloadActiveCalendar();
      }
    };

    loadData();
  }, []);



  if (acad.loading) {
    return <LoadingBtn />;
  } else if (acad.message) {
    return <AlertNotif message={acad.message} color="danger" />
  } else if (acad.data && Object.values(acad.data).length > 0) {
    if (AuthDecode) {
      if (AuthDecode.currentData.entityid === 0 || AuthDecode.currentData.entityid === "") {
        return <CardUnregis />;
      } else if (currDatetime >= AuthDecode.ExpiredSession) {
        return <CardSessionTimeout />;
      } else {
        if (is_student === false) {
          return <RouteLecturer data={menu} />;
        } else {
          return <FilterStudentPage menu={menu} student_data={std_data} />
        }
      }
    } else {
      return <Error404 />;
    }
  } else {
    return <Error404 />;
  }
}

const FilterStudentPage = ({ menu, student_data }) => {
  if (student_data && student_data.data && Object.values(student_data.data).length > 0) {
    if (student_data.data.type_student === 1) {
      return <StudentPage studentid={student_data.data?.studentid || ""} student_data={student_data.data} menu={menu} />;
    } else if (student_data.data.type_student === 2) {
      return <StudentNC student_data={student_data.data} />
    } else {
      return <AlertNotif title={`Information`} message={`Your are not allowed to access this portal, please contact IST Team`} color={`info`} />
    }
  } else {
    return <Error404 />
  }
}

const StudentPage = ({ studentid, menu, student_data }) => {
  const encstudentid = useMemo(() => studentid ? Buffer.from(studentid.toString()).toString("base64") : "", [studentid]);
  const urlLais = useMemo(() => `${packageJson.system_param.LAIS}lais/index?pg=${encstudentid}`, [encstudentid]);
  const urlSurvey = useMemo(() => `${packageJson.system_param.LAIS}internship/`, []);

  
  const [lais, setLais] = useState({ loading: false, data: 0, message: "" });
  const [internship, setInternship] = useState({ loading: false, data: 0, message: "", uri: "" });

  useEffect(() => {
    const checkSurveys = async () => {
      try {
        await Promise.all([
          CheckIsLais(setLais, urlLais),
          CheckSurvey(setInternship, urlSurvey, encstudentid),
        ]);
      } catch (error) {
        console.error("Error checking surveys:", error);
        openModal({message:<PopUpMessage title={`Error LAIS Detected`} message={error?.message || 'Failed checking LAIS Surveys'} type={'error'} />})
      }
    };

    checkSurveys();
  }, [student_data, urlLais, urlSurvey, encstudentid]);

  useEffect(() => {
    if (internship.data === 1 && internship.uri) {
      window.location.replace(internship.uri);
    }
  }, [internship]);

  if (!studentid) {
    return <Error404 />;
  }

  if (lais.data > 0) {
    return <CardLais url={urlLais} title="LAIS" />;
  }

  if (internship.data > 0) {
    return <CardLais url={urlSurvey} title="Internship" />;
  }

  if (Object.values(menu).length > 0) {
    return <RouteStudent routers={menu} student={student_data} />;
  }

  return <Error404 />;
}

const StudentNC = ({student_data}) =>{
  return <RouteStudentNewComming student={student_data} />
}